<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap style="direction:rtl">
        <v-flex
          v-if="permissions.store_item_transfer_report == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/StoreItemTransferReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              الاصناف المحولة للمخازن
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="
            permissions.store_one_item_transfer_report == 1 || user.type == 1
          "
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/StoreOneItemTransferReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              صنف محول للمخازن
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.store_movement_report == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/StoreMovementReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              حركة مخزن من الي
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.store_movement_all_report == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/StoreMovementReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />حركة جميع المخازن من الي
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.store_gard == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/StoreGard')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              جرد مخزن
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
  }
};
</script>
